<template>
  <a
    class="c-action-links__btn c-btn js-highlight_generate_pdf"
    href="#"
    @click="onclick($event)"
  >
  <span v-if="!$store.state.printToPdfInProgress">
    PDF generieren
  </span>
      <span v-else>wird generiert &hellip;</span>
  </a>
</template>

<script>
export default {
  name: 'AppActionLinksGeneratePDF',
  emits: ['generate-pdf'],
  methods: {
    onclick(event) {
      this.$emit('generate-pdf', event);
      if (gtag !== undefined) {
        gtag('event', 'generate_pdf', {
          send_to: window.mockuptoolSettings.analyticsTracker,
          page_title: $('title').text(),
          page_location: window.location.pathname
        });
      }
    }
  }
}
</script>

<style lang="less">
</style>